import React, { useId } from "react";

const SimpleToggleButton = ({
  checked,
  onChange,
  disabled = false,
  className = "",
  testId,
  ariaLabel = "Toggle",
}) => {
  const generatedId = useId();
  const toggleId = testId || `simple-toggle-${generatedId}`;

  const handleToggleClick = (e) => {
    if (disabled) return;
    e.preventDefault();
    e.stopPropagation();
    onChange(!checked);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.stopPropagation();
    }
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-disabled={disabled}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={handleToggleClick}
      onKeyDown={handleKeyDown}
      id={toggleId}
      className={`relative inline-flex items-center border-0 bg-transparent p-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-cfPrimaryButton focus-visible:ring-offset-2 rounded-full ${
        disabled
          ? "cursor-not-allowed opacity-50"
          : "cursor-pointer hover:opacity-90"
      } ${className}`}
    >
      <div
        className={`pointer-events-none w-11 h-6 rounded-full transition-colors duration-200 ${
          checked ? "bg-cfPrimaryButton" : "bg-gray-200"
        }
          ${checked ? "after:translate-x-full after:border-white" : ""}
          after:content-[''] after:absolute after:top-[2px] after:left-[2px] 
          after:bg-white after:border-gray-300 after:border after:rounded-full 
          after:h-5 after:w-5 after:transition-all`}
        aria-hidden="true"
      ></div>
    </button>
  );
};

export default SimpleToggleButton;
